import {
  Svg,
  SvgG,
  SvgPath,
  type SvgProps,
  SvgRect,
  registerSVG,
} from '../../../src/components/svg';

export function PlkMenu(props: SvgProps) {
  return (
    <Svg {...props} viewBox="0 0 16 24">
      <SvgG transform="translate(-16 -8)" fillRule="evenodd">
        <SvgRect x={16} y={13} width={16} height={19} rx={0.5} />
        <SvgPath
          d="M29 11.5V8.694a.5.5 0 0 0-.658-.475l-8.419 2.807a.5.5 0 0 0 .158.974H28.5a.5.5 0 0 0
        .5-.5z"
        />
      </SvgG>
    </Svg>
  );
}

registerSVG('PlkMenu', PlkMenu);
